import React, {useMemo, useEffect} from 'react';
import {useTable, usePagination, useFilters, useRowSelect} from 'react-table';
import {
  Table,
  Button,
  Dropdown,
  Input,
  Popup,
  Grid,
  Modal,
} from 'semantic-ui-react';
import {Filter, DefaultColumnFilter} from '../internalCommons/TableFilters';
import {invoicesPageSizes} from '../../../common/constants/lists';
import {Actions} from '../../../common/actions';
import {connect} from 'react-redux';

const originsTableHeaderWithProps = (
  loading,
  activateOrigin,
  fetchDeleteOrigin
) => {
  return [
    {
      'Header': () => <span className='header-title'>CÓDIGO DE PAÍS</span>,
      'accessor': 'country',
      'width': 150,
      'className': 'cell-custom',
    },
    {
      'Header': () => <span className='header-title'>NOMBRE DE PAÍS</span>,
      'accessor': 'description',
      'width': 250,
      'className': 'cell-custom',
    },
    {
      'Header': () => <span className='header-title'>TIEMPO DE LLEGADA (MESES)</span>,
      'accessor': 'arrival_time',
      'width': 150,
      'className': 'cell-custom',
    },
    {
      'Header': () => <span className='header-title'>CÓDIGO DE PAÍS EQIVALENTE</span>,
      'accessor': 'country_equivalence',
      'width': 150,
      'className': 'cell-custom',
    },
    {
      'Header': () => <span className='header-title'>ACTIVOS</span>,
      'accessor': 'active',
      'width': 150,
      'className': 'cell-custom',
    },
    {
      'id': 'actions',
      'Header': () => <span className='header-title'>ACCIONES</span>,
      'width': 150,
      'disableFilters': true,
      'className': 'cell-custom',
      'Cell': ({row}) => {
        const handleEditOrigin = () => {
          activateOrigin(row.original);
        };
        const handleDeleteOrigin = () => {
          fetchDeleteOrigin(row.original.country);
        };
        return (
          <>
            <Popup
              trigger={
                <span className="link" onClick={handleEditOrigin}>
                  <i className="material-icons" disabled={loading}>
                    {'edit'}
                  </i>
                </span>
              }
              content={'Editar'}
              position="top center"
              inverted
            />

            <Modal
              size={'mini'}
              trigger={
                <span className="link">
                  <Popup
                    trigger={
                      <span className="link">
                        <i className="material-icons" disabled={loading}>
                          {'delete'}
                        </i>
                      </span>
                    }
                    content="Eliminar"
                    position="top center"
                    inverted
                  />
                </span>
              }
              header="¿Está seguro que desea eliminar el orígen seleccionado?"
              actions={[
                {'key': 'cancel', 'content': 'Cancelar'},
                {
                  'key': 'done',
                  'content': 'Confirmar',
                  'positive': true,
                  'onClick': () => handleDeleteOrigin(),
                  'primary': true,
                },
              ]}
            />
          </>
        );
      },
    },
  ];
};

const TablePaginator = ({
  page,
  canPreviousPage,
  pageIndex,
  pageOptions,
  pageSize,
  canNextPage,
  nextPage,
  gotoPage,
  previousPage,
  setPageSize,
}) => {
  if (page.length) {
    return (
      <Grid className="pagination">
        <Grid.Row>
          <Grid.Column width={4} textAlign="left">
            <Button
              className="navigation-button"
              onClick={() => previousPage()}
              disabled={!canPreviousPage}
              content="Anterior"
            />
          </Grid.Column>
          <Grid.Column width={4} textAlign="right">
            <span>páginas </span>
            <span>
              <Input
                className="pages-input"
                type="number"
                value={pageIndex + 1}
                min="1"
                max={pageOptions.length}
                onChange={(e, {value}) => {
                  const page = value ? Number(value) - 1 : 0;
                  if (page < 1 || page > pageOptions.length) {
                    e.target.value = 1;
                  }
                  gotoPage(page);
                }}
              />
            </span>{' '}
            <span>de {pageOptions.length}</span>
          </Grid.Column>
          <Grid.Column width={4} textAlign="left">
            <Dropdown
              className="page-sizes-selection"
              selection
              upward
              compact
              value={pageSize}
              options={invoicesPageSizes}
              onChange={(e, {value}) => {
                setPageSize(Number(value));
              }}
            />
            <span> filas</span>
          </Grid.Column>
          <Grid.Column width={4} textAlign="right">
            <Button
              className="navigation-button"
              onClick={() => nextPage()}
              disabled={!canNextPage}
              content="Siguiente"
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
  return null;
};

const OriginsParametersTable = ({
  loading,
  dataTable,
  handleChange,
  countRows,
  activateOrigin,
  fetchDeleteOrigin,
  fetchOrigins,
}) => {
  const columnsTable = originsTableHeaderWithProps(
    loading,
    activateOrigin,
    fetchDeleteOrigin,
    fetchOrigins
  );
  const data = useMemo(() => dataTable, [dataTable]);
  const columns = useMemo(() => columnsTable, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    rows,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    'state': {pageIndex, pageSize},
  } = useTable(
    {
      columns,
      data,
      'defaultColumn': {'Filter': DefaultColumnFilter},
      'initialState': {'pageIndex': 0, 'pageSize': 20},
    },
    useFilters,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    if (rows.length !== countRows) {
      handleChange('countRows', rows.length);
    }
  }, [rows]);

  return (
    <>
      <div className='table-wrapper origins-table'>
        <Table className="interactive" compact striped {...getTableProps()}>
          <Table.Header className='sticky'>
            {headerGroups.map((headerGroup) => (
              <Table.Row key="headers" {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell
                    key={`title-${index}`}
                    textAlign="center"
                    {...column.getHeaderProps()}
                  >
                    {column.render('Header')}
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
            {headerGroups.map((headerGroup) => (
              <Table.Row key="filters" id="filters">
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell key={`filter-${index}`} textAlign="center">
                    <Filter column={column} />
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
          </Table.Header>
          <Table.Body {...getTableBodyProps()}>
            {!page.length && (
              <Table.Row>
                <Table.Cell colSpan={15} textAlign="center">
                  No hay datos disponibles
                </Table.Cell>
              </Table.Row>
            )}
            {page.length > 0 &&
              page.map((row, i) => {
                prepareRow(row);
                return (
                  <Table.Row
                    key={i}
                    className={`
                  row-custom cell-custom-inventory-models ${i % 2 === 0 ? 'table-row-odd' : 'table-row-even'}
                  `}
                  >
                    {row.cells.map((cell) => {
                      return (
                        <Table.Cell
                          textAlign="center"
                          className={cell.column.className}
                        >
                          {cell.render('Cell')}
                        </Table.Cell>
                      );
                    })}
                  </Table.Row>
                );
              })}
          </Table.Body>
        </Table>
      </div>
      <TablePaginator
        page={page}
        canPreviousPage={canPreviousPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        pageSize={pageSize}
        canNextPage={canNextPage}
        nextPage={nextPage}
        gotoPage={gotoPage}
        previousPage={previousPage}
        setPageSize={setPageSize}
      />
    </>
  );
};

const {activateOrigin, fetchDeleteOrigin, fetchOrigins} = Actions;

export default connect(null, {
  activateOrigin,
  fetchDeleteOrigin,
  fetchOrigins,
})(OriginsParametersTable);
